<template>
  <view-wrapper
    name="Active Agents"
    :loading="loading"
    :loadingText="loadingText"
  >
    <wrapper class="mb-5" :check-for-child-focused="true">
      <filter-and-sort-box
        :data="filteredAgents"
        :headers="headers"
        :useSearch="true"
        @searchQuery="searchText = $event"
        :columnsToNotSort="columnsToNotSort"
      >
        <template v-slot:rows="{ rows }">
          <tr class="bg-primary" v-for="(d, index) in rows" :key="index">
            <td
              class="py-2"
              :key="key + index1"
              v-for="(key, index1) in Object.keys(headers)"
            >
              {{ d[key] }}
            </td>
            <td class="p-2">
              <icon-button
                tooltip="Release Agent"
                @click="openReleaseConfirmation(d)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 text-highlight"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                  />
                </svg>
              </icon-button>
            </td>
          </tr>
        </template>
      </filter-and-sort-box>
    </wrapper>
    <modal
      v-if="isConfirmReleaseOpen"
      @close="closeReleaseConfirmation"
      type="success"
    >
      <template slot="header">
        <svg
          v-if="!isReleasing"
          width="106"
          height="106"
          viewBox="0 0 106 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 53C0 23.744 23.744 0 53 0C82.256 0 106 23.744 106 53C106 82.256 82.256 106 53 106C23.744 106 0 82.256 0 53ZM7 52.5C7 78.1913 27.8088 99 53.5 99C79.1913 99 100 78.1913 100 52.5C100 26.8088 79.1913 6 53.5 6C27.8088 6 7 26.8088 7 52.5Z"
            fill="white"
          />
          <rect x="48" y="28" width="10" height="32" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53 78C56.3137 78 59 75.3137 59 72C59 68.6863 56.3137 66 53 66C49.6863 66 47 68.6863 47 72C47 75.3137 49.6863 78 53 78Z"
            fill="white"
          />
        </svg>
        <template v-if="isReleasing">
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
        </template>
      </template>
      <template slot="body">
        <h3>Are you sure?</h3>
        <p>This action cannot be reverted</p>
      </template>
      <template slot="buttons">
        <grafokett-button
          class="mb-2 mr-4 button hover:text-highlight"
          @click="closeReleaseConfirmation"
          >No</grafokett-button
        >
        <grafokett-button
          class="mb-2 text-white button bg-primary-light white"
          @click="releaseAgent()"
          >Yes</grafokett-button
        >
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import FilterAndSortBox from "../components/FilterAndSortBox.vue";
import IconButton from "../components/IconButton.vue";
import Modal from "../components/Modal.vue";
import ViewWrapper from "../components/ViewWrapper.vue";
import Wrapper from "../components/Wrapper.vue";
import GrafokettButton from "../components/forms/Button.vue";

export default {
  components: {
    ViewWrapper,
    Wrapper,
    FilterAndSortBox,
    IconButton,
    Modal,
    GrafokettButton,
  },
  data() {
    return {
      loading: false,
      loadingText: "Loading Active Agents",
      agents: [],
      searchText: "",
      headers: {
        computerName: "Computer Name",
        userId: "User ID",
        macAddress: "MAC Address",
        actions: "",
      },
      columnsToNotSort: ["actions"],
      isReleasing: false,
      isConfirmReleaseOpen: false,
      agentToRelease: null,
    };
  },
  methods: {
    async getData() {
      this.loading = true;

      const { data } = await this.$store.$api.get("/api/agents/active");

      this.agents = data && data.data;

      this.loading = false;
    },
    async releaseAgent() {
      this.isReleasing = true;

      await this.$store.$api.delete(
        `/api/agents/active/${this.agentToRelease.userId}/${
          this.agentToRelease.computerName
        }`
      );

      this.agents = [
        ...this.agents.filter(
          i =>
            !(
              i.userId === this.agentToRelease.userId &&
              i.computerName === this.agentToRelease.computerName &&
              i.macAddress === this.agentToRelease.macAddress
            )
        ),
      ];

      this.isReleasing = false;
      this.isConfirmReleaseOpen = false;
    },
    openReleaseConfirmation(agent) {
      this.isReleasing = false;
      this.isConfirmReleaseOpen = true;
      this.agentToRelease = agent;
    },
    closeReleaseConfirmation() {
      this.isReleasing = false;
      this.isConfirmReleaseOpen = false;
      this.agentToRelease = null;
    },
  },
  computed: {
    filteredAgents() {
      if (!this.searchText || this.searchText.length <= 0) return this.agents;

      return this.agents.filter(
        x =>
          x.computerName.toLowerCase().indexOf(this.searchText.toLowerCase()) >
          -1
      );
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>

<style lang="postcss" scoped>
.loading-span {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  animation: rotate 2s linear infinite both;
}

.loading-span:nth-of-type(1) {
  animation-delay: 0.2s;
}

.loading-span:nth-of-type(2) {
  animation: rotate 2s 0.4s linear infinite both;
}

.loading-span:nth-of-type(3) {
  animation: rotate 2s 0.6s linear infinite both;
}

.loading-span:nth-of-type(4) {
  animation-delay: 0.8s;
}

.loading-span:nth-of-type(5) {
  animation-delay: 1s;
}

@keyframes rotate {
  from {
    transform: rotate(0deg) translateY(-200%) rotate(0deg) scale(0.2);
  }
  50% {
    transform: rotate(360deg) translateY(-200%) rotate(-360deg) scale(1);
  }

  to {
    transform: rotate(360deg) translateY(-200%) rotate(-360deg) scale(0);
  }
}

td:first-of-type {
  @apply pl-2;
}

td:last-of-type {
  @apply pr-2;
}
</style>
